<template>
	<div class="page_wrap">
		<div class="img_bg">
			<img src="../../public/img/szr/Group 1321315441.png" alt="" />
		</div>
		<div class="list_wrap" ref="inner">
		    <div class="li" v-for="item in list">
		      <div class="q_wrap">
		      	<div class="q">{{item.q}}</div>
		       </div>
		      <div class="a_wrap">
		      	<div class="a" v-if="item.a"> 
					<mavon-editor
					  ref="markdown"
					  v-model="item.a"
					  defaultStyle="display:none;"
					  :subfield="false"
					  defaultOpen='preview'
					  :boxShadow="false"
					  :scrollStyle="false"
					  :toolbars="toolbars"
					  :editable="false"
					/>		      		
		      	</div>		      	
				<div class="load" v-else>
					<span style="margin-right: 5px;">请稍后</span>
					<span class="icon">
						<div class="point dot1"></div>
						<div class="point dot2"></div>
						<div class="point dot3"></div>
					</span>
				</div>		      	

		      </div>
		    </div> 
		</div>
		<div class="footer">
			<div class="input">
				<el-input  placeholder="请输入内容" size="small" v-model="sendMessage"></el-input>
			</div>
			<div class="btn" >
				<img src="../../public/img/szr/03.png" alt="" v-if="loading"/>
				<img src="../../public/img/szr/02.png" alt="" v-else @click="send"/>
				
			</div>				
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			    toolbars: {
			      bold: false,
			      italic: false,
			      code: false,
			      link: false,
			    },						
                 sendMessage:'',
                 list:[],
                 modelName:'qwen3.5-kt',
                 apikey:'jskt1234',
                 loading:false
			};
		},
		methods: {
			async send(){	
				this.loading=true
				let obj={
					q:this.sendMessage,
					a:''
				}
				this.list.push(obj)
				

				let that=this
  			    that.$nextTick(() => {
  			  	  that.$refs.inner.scrollTo(0,that.$refs.inner.scrollHeight+160)
  			    })				
				let requestBody ={
					    "model": this.modelName,
					    "stream": true,
					    "messages": [
					      {"role": "user", "content": this.sendMessage}
					    ],
					    "temperature": 0.3,
					    "top_p": 0.9,
					    "max_tokens": 8192,
					    "chat_template_kwargs": {"enable_thinking": true}						
				}
//				http://221.131.97.90:7000
//              https://sjc.ht-zl.com.cn
				let response=await fetch('https://sjc.ht-zl.com.cn/v1/chat/completions',{
					method:'post',
					responseType:'stream',
					headers:{
						'Content-type':'application/json',
						"Authorization": "Bearer "+this.apikey
					},
					body:JSON.stringify(requestBody)
				})
				if(!response.ok){
					throw new Error('Network response is not ok!')
				}
				const reader=response.body.getReader()
				const textDecoder= new TextDecoder()
				let result=true
                let sqlValue=''
                let start=false
			    while (result) {
			      const { done, value } = await reader.read();
			      if (done){
			      	result=false;
			      	break
			      };
			      const chunkText=textDecoder.decode(value).split("\n").forEach(val=>{
			      	if(!val){
			      		return
			      	}
			      	if(val.indexOf('DONE')>=0){
			      		return
			      	}else if(val.indexOf('}]}')<0){
			      		return 
			      	}else if(val.indexOf('think')>=0){
			      		return 
			      	}
			      	else if(val.indexOf('data:')>=0){
			      		let text=val?val.replace("data:",""):''
			      		let content=JSON.parse(text)
			      		let msg=content.choices[0].delta.content
			      		
			      		if(msg){
			      			that.list[that.list.length-1].a+=msg;
		      			    that.$nextTick(() => {
		      			  	  that.$refs.inner.scrollTo(0,that.$refs.inner.scrollHeight+160)
		      			    })
	
			      		}
			      	}
			      })

			    }
			    this.sendMessage=''
			    this.loading=false
//				this.playVideo()
			},			
		},
		mounted() {
//		    fetch('https://sjc.ht-zl.com.cn/v1/models')
//			  .then(response => {
//			    if (!response.ok) {
//			      throw new Error(`请求失败：${response.status}`);
//			    }
//			    return response.text(); 
//			  })
//			  .then(text => {
//			    let result=JSON.parse(text)			    
//			    this.modelName=result.data[0].id;
//			    this.apikey=result.data[0].permission[0].id
//			   
//			  })
//			  .catch(error => {
//			    console.error('请求出错：', error);
//			  });						
		},

		
	};
</script>

<style lang="scss" scoped>
/* 去掉外层边框、背景、阴影 */
::v-deep .mavon-editor {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
::v-deep .v-note-op{
	display: none!important;
}

.v-note-wrapper{
	border: none;
	background: transparent;
}
::v-deep .v-show-content{
	background: transparent!important;
	overflow-x: hidden !important;
	overflow-y: visible !important;
}
/* 隐藏滚动条 + 取消默认滚动 */
::v-deep .mavon-editor-container {
  overflow: hidden !important;
}
::v-deep .markdown-body {
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

::v-deep .markdown-body .markdown-table-scroll {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 12px 0;
  -webkit-overflow-scrolling: touch;
}

::v-deep .markdown-body table {
  width: max-content !important;
  min-width: 760px;
  max-width: none !important;
  table-layout: auto;
  border-collapse: collapse;
  margin: 0;
}

::v-deep .markdown-body table th,
::v-deep .markdown-body table td {
  min-width: 90px;
  white-space: nowrap;
}
		*{
			box-sizing: border-box;
		}
	    @keyframes printPaper {
	      0% { opacity: 0; }
	      100% { opacity: 1; }
	    }		
		.load{
			background: linear-gradient( 123deg, #ADDDF8 0%, #E1E2F8 38.46%, #F3F9FF 100%);
			padding: 20px 10px;	
			border-radius: 20px 20px 10px 20px;	
		    color: #333;
		    display: flex;
		    align-items: center;
		    .icon{
		    	position: relative;
			    display: flex;
			    .point{
				    width: 5px;
				    height: 5px;
				    background-color: #5f8cff;
				    border-radius: 2.5px;
				    margin: 2px;
				    display: inline-block;			    	
			    }
			    .dot1{
                   animation: printPaper 1.5s ease infinite;		    	
			    }
			    .dot2{
				    animation: printPaper 1.5s ease infinite;
				    animation-delay: .5s;			    	
			    }
			    .dot3{
				    animation: printPaper 1.5s ease infinite;
				    animation-delay: 1s;			    	
			    }
		    }			
		}
	.page_wrap {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		
		background: linear-gradient( 123deg, #ADDDF8 0%, #E1E2F8 38.46%, #F3F9FF 100%);
		margin-top: 10px;
		padding: 10px 20px;
		.img_bg{
			img{
				width: 100%;
			}
		}
		
	    .list_wrap::-webkit-scrollbar {
	      display: none; /* 隐藏Webkit滚动条 */
	    }		
		.list_wrap{
			padding: 0;
			overflow: auto;
			flex: 1;
			margin-bottom: 30px;
			.q_wrap{
				margin-top: 20px;
				display: flex;
				justify-content: flex-end;
				.q{
					max-width: 60%;
					background: linear-gradient( 180deg, #F5FAFF 0%, #FFFFFF 100%);
					border-radius: 20px 20px 10px 20px;
					border: 2px solid #FFFFFF;			
					padding: 20px 10px;	
					font-size: 14px;					
				}
			}
			.a_wrap{
				margin-top: 20px;
				display: flex;
				justify-content: flex-start;				
				.a{
	                background: linear-gradient( 180deg, #F5FAFF 0%, #FFFFFF 100%);	
	                border-radius: 20px 20px 10px 20px;		
	                border: 2px solid #FFFFFF;	
					padding: 20px 10px;	
					font-size: 14px;						
				}                
			}
		}
		
		.footer{
			display: flex;
			align-items: center;
			background: #FFFFFF;
			border-radius: 42px 42px 42px 42px;
			border: 1px solid #D9D9D9;
			padding: 10px 30px;
			margin-bottom: 10px;
			.input{
				flex: 1;
			    /deep/ .el-input__inner{
			    	border:none			    	
			    }   				
			}
			.btn{
				margin-left: 15px;
				img{
					width: 30px;
					display: block;
				}
			}
		}
	}
</style>